import {Variant} from './types';

const defaultVariantProp: Variant = {
	title: 'body2',
	value: 'subtitle1',
};

export {defaultVariantProp};
